<app-table [TableHeader]="table_header" [location]="true" [pageNation]="true" [paginationPageSizeSelector]="[10,20,50]"
    (onPageChange)="handlePageChange($event)" [maxRowCount]="totalcount"></app-table>